import { useTrustCenterConfig } from '@/contexts/TrustCenterContext'
import type { ITrustCenterResource } from '@/types/trust-center/trustCenterConfig'

export interface IDocument {
  resource: ITrustCenterResource
  isPublic: boolean
}

export function useDocuments() {
  const { resources } = useTrustCenterConfig()
  const documents: IDocument[] = [
    ...resources.public.map((resource) => ({ resource, isPublic: true })),
    ...resources.private.map((resource) => ({ resource, isPublic: false })),
  ]
  const privateNames = resources.private.map((resource) => resource.name)
  return { documents, privateNames }
}
